































































































































import { extend, ValidationObserver, ValidationProvider } from 'vee-validate'
import { required, max } from 'vee-validate/dist/rules'

import { Component, Vue } from 'vue-property-decorator'
import { CalendarAssignmentInterface } from '@/commerce/Common/interfaces/calendar-assignment.interface'
import { CalendarTemplateInterface } from '@/commerce/Common/interfaces/calendar-template.interface'
import { calendarTemplateService } from '@/commerce/Common/services/calendar-template.service'

extend('required', required)
extend('max', max)

@Component({
    components: {
        ValidationObserver,
        ValidationProvider
    }
})
export default class CalendarTemplateList extends Vue {
    $refs!: {
        observer: InstanceType<typeof ValidationObserver>
    }

    private loading: boolean = false
    private assignments: CalendarAssignmentInterface[]

    public calendarTemplates: CalendarTemplateInterface[]
    public dialog: boolean = false
    public dialogDelete: boolean = false
    public editedIndex: number = -1
    public editedItem: CalendarTemplateInterface
    public defaultItem: CalendarTemplateInterface

    data() {
        return {
            dialog: false,
            dialogDelete: false,
            headers: [
                {
                    text: 'Name',
                    value: 'Name',
                },
                {
                    text: 'Description',
                    value: 'AdminDescription',
                },
                {
                    text: 'Actions',
                    value: 'actions',
                    align: 'end',
                    sortable: false
                }
            ],
            calendarTemplates: [],
            editedIndex: -1,
            editedItem: {
                Name: '',
                AdminDescription: '',
                UserDescription: '',
                ShowLowInventory: false,
                LowInventoryThreshold: 0,
                LowInventoryLabel: 'LOW'
            },
            defaultItem: {
                Name: '',
                AdminDescription: '',
                UserDescription: '',
                ShowLowInventory: false,
                LowInventoryThreshold: 0,
                LowInventoryLabel: 'LOW'
            },
            assignments: []
        };
    }

    get formTitle(): string {
        return this.editedIndex === -1 ? 'Create New Calendar Template' : 'Edit Calendar Template'
    }

    get hasAssignments(): boolean {
        return this.editedIndex != -1 && this.assignedProducts.length > 0
    }

    get assignedProducts(): CalendarAssignmentInterface[] {
        if (!this.editedItem) {
            return []
        }
        return this.assignments?.filter((x) => x.CalendarTemplateId == this.editedItem.Id)
    }

    async created() {
        this.calendarTemplates = await calendarTemplateService.getCalendarTemplates()

        // TODO consider moving this to vuex store
        this.assignments = await calendarTemplateService.getAssignments()
    }


    async updateCalendarTemplate() {
        if (this.editedItem) {
            this.loading = true
            await calendarTemplateService.updateCalendarTemplate(this.editedItem)
            this.loading = false
        }
    }

    editItem(item) {
        this.editedIndex = this.calendarTemplates.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
    }

    deleteItem(item) {
        this.editedIndex = this.calendarTemplates.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
    }

    async deleteItemConfirm() {
        if (this.editedItem) {
            this.loading = true
            await calendarTemplateService.deleteCalendarTemplate(this.editedItem)
            this.calendarTemplates.splice(this.editedIndex, 1)
            this.loading = false
        }

        this.closeDelete()
    }

    close() {
        this.dialog = false
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1
        })
    }

    closeDelete() {
        this.dialogDelete = false
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1
        })
    }

    async submitForm() {
        this.loading = true
        const isPreValid = this.isDuplicateName()
        if (!isPreValid) {
            return
        }

        const isValid = await this.$refs.observer.validate()
        if (!isValid) {
            return
        }

        if (this.editedIndex > -1) {
            await calendarTemplateService.updateCalendarTemplate(this.editedItem)
            Object.assign(this.calendarTemplates[this.editedIndex], this.editedItem)
        } else {
            let response = await calendarTemplateService.createCalendarTemplate(this.editedItem)
            this.calendarTemplates.push(response)
        }
        this.loading = false
        this.close()
    }

    private isDuplicateName(): boolean {
        const isDuplicate = this.calendarTemplates
            .some((x) =>
                x.Id != this.editedItem?.Id
                && x.Name == this.editedItem?.Name)

        if (isDuplicate) {
            this.$refs['name-validator'].applyResult({
                errors: ['A calendar template already exists with this name'],
                valid: false,
                failedRules: {},
            })
            return false
        }
        return true
    }
}
